/**
 * Firebase Collections Configuration
 * 
 * جميع أسماء الـ Collections مخزنة هنا في ملف واحد
 * يمكنك تغيير البادئة أو الأسماء من هنا فقط
 */

export const COLLECTIONS = {
    ORDERS: 'lc_orders',
    PRODUCTS: 'lc_products',
    CATEGORIES: 'lc_categories',
    SERVICES: 'lc_services',
    MODIFICATIONS: 'lc_modifications',
    CUSTOMERS: 'lc_customers',
    NOTIFICATIONS: 'lc_notifications',
    TEST: 'lc_test'
};

// للتوافق مع الكود القديم - يمكن استخدام الأسماء المختصرة
export const {
    ORDERS,
    PRODUCTS,
    CATEGORIES,
    SERVICES,
    MODIFICATIONS,
    CUSTOMERS,
    NOTIFICATIONS,
    TEST
} = COLLECTIONS;

export default COLLECTIONS;
